export const BrandImage = ({ pic }) => {
  return (
    <div className="projects-opening-brand-container">
      <img className="projects-opening-brand" src={pic} />
    </div>
  );
};
